import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './MeasurementLeftMenuBar.css';
import '../../App.css';

import { changeStateSelDeviceIv, changeStateSelDeviceJb, changeStateSelDeviceEv } from '../../store';

function MeasurementLeftMenuBar() {
  const dispatch = useDispatch();
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const Jb_list = useSelector((state) => state.Jb_list || {});

  const [submenuVisible, setSubmenuVisible] = useState(0);
  const [inverterList, setInverterList] = useState([]);
  const [jbList, setJbList] = useState([]);

  const [selectedInverter, setSelectedInverter] = useState(null);
  const [selectedJb, setSelectedJb] = useState(null);
  const [selectedEv, setSelectedEv] = useState(null);

  // 페이지가 처음 로드될 때 인버터의 첫 번째 장비 자동 선택
  useEffect(() => {
    if (Iv_list.seq && Array.isArray(Iv_list.seq) && Iv_list.seq.length > 0) {
      setInverterList(Iv_list.seq);

      // 처음 로드될 때만 첫 번째 인버터 자동 선택 (selectedJb가 없고 selectedInverter도 없을 때)
      if (selectedInverter === null && selectedJb === null && selectedEv === null) {
        setSelectedInverter(Iv_list.seq[0]);
        dispatch(changeStateSelDeviceIv(Iv_list.seq[0]));
      }
    }
  }, [Iv_list, selectedInverter, selectedJb, selectedEv, dispatch]);

  const toggleSubmenu = (changeMenu) => {
    setSubmenuVisible(changeMenu);
    if (changeMenu === 0 && inverterList.length > 0 && selectedInverter === null) {
      // 인버터 메뉴를 열었을 때, 인버터가 선택되지 않았다면 첫 번째 장비 선택
      setSelectedInverter(inverterList[0]);
      dispatch(changeStateSelDeviceIv(inverterList[0]));
      setSelectedJb(null); // 인버터가 선택되면 접속함 선택 해제
      dispatch(changeStateSelDeviceJb(null));
      setSelectedEv(null);
      dispatch(changeStateSelDeviceEv(null));
    } else if (changeMenu === 1 && jbList.length > 0 && selectedJb === null) {
      // 접속함 메뉴를 열었을 때, 접속함이 선택되지 않았다면 첫 번째 장비 선택
      setSelectedJb(jbList[0]);
      dispatch(changeStateSelDeviceJb(jbList[0]));
      setSelectedInverter(null); // 접속함이 선택되면 인버터 선택 해제
      dispatch(changeStateSelDeviceIv(null));
      setSelectedEv(null);
      dispatch(changeStateSelDeviceEv(null));
    } else if (changeMenu === 2) {
      // EV 메뉴를 열었을 때, EV 장비 선택
      setSelectedEv(1);
      dispatch(changeStateSelDeviceEv(1)); // 이 부분 수정
      setSelectedInverter(null);
      dispatch(changeStateSelDeviceIv(null));
      setSelectedJb(null);
      dispatch(changeStateSelDeviceJb(null));
    }
  };

  useEffect(() => {
    if (Jb_list.seq && Array.isArray(Jb_list.seq)) {
      const seqArr = Jb_list.seq || [];
      const protoArr = Jb_list.jb_protocol || [];
      const pairArr = (Jb_list.pair_device || Jb_list.pair_seq) || [];

      const isMrtPairedToG2 = (i) => {
        if (protoArr[i] !== '엠알티-표준') return false;
        const pairSeq = pairArr[i];
        if (pairSeq != null) {
          const pIdx = seqArr.findIndex((s) => s === pairSeq);
          return pIdx !== -1 && protoArr[pIdx] === '지투파워';
        }
        const reverseIdx = seqArr.findIndex((_, j) => protoArr[j] === '지투파워' && pairArr[j] === seqArr[i]);
        return reverseIdx !== -1;
      };

      // 비엔엠 부모만 보이고, 그에 페어된 Bnm_lc/Bnm_co는 숨김
      const isBnmChild = (i) => {
        const p = String(protoArr[i] || '').toLowerCase();
        if (p === 'bnm_lc' || p === 'bnm-lc' || p === 'bnmco' || p === 'bnm_co' || p === 'bnm-co') return true;
        const parentSeq = pairArr[i];
        if (parentSeq == null) return false;
        const pIdx = seqArr.findIndex((s) => s === parentSeq);
        return pIdx !== -1 && protoArr[pIdx] === '비엔엠';
      };

      const collapsedSeqs = seqArr.filter((_, i) => !isMrtPairedToG2(i) && !isBnmChild(i));
      setJbList(collapsedSeqs);
    }
  }, [Jb_list]);

  return (
    <div className="sidebar">
      {/* 계측장비 타이틀 표시 */}
      <div className="measurment-image-wrap">
        <div className="measurment-image-container">
          <div
            className="measurement-title-image-crop"
            style={{ top: "-27px", left: "-27px" }}
          ></div>
        </div>
        <div>
          <div
            style={{
              paddingLeft: "15px",
              fontSize: "x-large",
              marginTop: "15px",
              marginBottom: "15px",
            }}
          >
            계측장비
          </div>
        </div>
      </div>

      {/* 인버터 메뉴 */}
      <div className="menu-item" onClick={() => toggleSubmenu(0)}>
        <div className="menu-name-container">
          {/* 서브메뉴가 열려있는 경우 색상 변경 */}
          {submenuVisible === 0 ? (
            <div style={{ color: "var(--brand-navy, #013c8f)" }}>인버터</div>
          ) : (
            <div>인버터</div>
          )}
          {/* 서브메뉴 열림/닫힘 아이콘 */}
          {submenuVisible === 0 ? <div>▲</div> : <div>▼</div>}
        </div>
      </div>
      {/* 인버터 리스트 (서브메뉴) */}
      {submenuVisible === 0 && (
        <div className="submenu" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          {/* 전체보기 메뉴 (항상 상단에 표시) */}
          <div
            className={`submenu-item ${selectedInverter === 'TotalList' ? 'selected' : ''}`}
            onClick={() => {
              setSelectedInverter('TotalList'); // 선택 해제
              dispatch(changeStateSelDeviceIv('TotalList')); // Redux 상태 null로 설정
              setSelectedJb(null);
              dispatch(changeStateSelDeviceJb(null));
            }}
            style={{ cursor: 'pointer' }}
          >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <div className={`menu-device-list ${selectedInverter === null ? '' : 'selected'}`}>
                {selectedInverter === 'TotalList' ? "▶" : ""}
              </div>
              <div style={{ paddingLeft: "10px" }}>전체보기</div>
            </div>
          </div>
          {/* 실제 인버터 목록 */}
          {inverterList.map((inverter, key) => (
            <div
              key={inverter}
              className={`submenu-item ${selectedInverter === inverter ? 'selected' : ''}`}
              onClick={() => {
                setSelectedInverter(inverter); // 선택한 인버터 저장
                dispatch(changeStateSelDeviceIv(inverter)); // Redux 상태 업데이트
                // 인버터를 선택하면 접속함을 null로 설정
                setSelectedJb(null); // 접속함 선택 초기화
                dispatch(changeStateSelDeviceJb(null)); // Redux 상태 업데이트
              }}
              style={{ cursor: "pointer" }}
            >
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                {/* 선택된 인버터일 경우 ▶ 표시 */}
                <div className={`menu-device-list ${selectedInverter === inverter ? '' : 'selected'}`}>
                  {selectedInverter === inverter ? "▶" : ""}
                </div>
                {/* 인버터 이름 표시 */}
                <div style={{ paddingLeft: "10px" }}>{Iv_list.iv_name[key]}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 접속함 메뉴 — 숨김 처리 */}
      {false && (
        <>
          <div className="menu-item" onClick={() => toggleSubmenu(1)}>
            <div className="menu-name-container">
              {submenuVisible === 1 ? (
                <div style={{ color: "var(--brand-navy, #013c8f)" }}>접속함</div>
              ) : (
                <div>접속함</div>
              )}
              {submenuVisible === 1 ? <div>▲</div> : <div>▼</div>}
            </div>
          </div>
          {submenuVisible === 1 && (
            <div className="submenu" style={{ maxHeight: '500px', overflowY: 'auto' }}>
              <div
                className={`submenu-item ${selectedJb === 'TotalList' ? 'selected' : ''}`}
                onClick={() => {
                  setSelectedJb('TotalList');
                  dispatch(changeStateSelDeviceJb('TotalList'));
                  setSelectedInverter(null);
                  dispatch(changeStateSelDeviceIv(null));
                }}
                style={{ cursor: "pointer" }}
              >
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <div className={`menu-device-list ${selectedJb === 'TotalList' ? '' : 'selected'}`}>
                    {selectedJb === 'TotalList' ? "▶" : ""}
                  </div>
                  <div style={{ paddingLeft: "10px" }}>전체 보기</div>
                </div>
              </div>
              {jbList.map((Jb, key) => (
                <div
                  key={Jb}
                  className={`submenu-item ${selectedJb === Jb ? 'selected' : ''}`}
                  onClick={() => {
                    setSelectedJb(Jb);
                    dispatch(changeStateSelDeviceJb(Jb));
                    setSelectedInverter(null);
                    dispatch(changeStateSelDeviceIv(null));
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <div className={`menu-device-list ${selectedJb === Jb ? '' : 'selected'}`}>
                      {selectedJb === Jb ? "▶" : ""}
                    </div>
                    <div style={{ paddingLeft: "10px" }}>
                      {(Jb_list.seq || []).includes(Jb)
                        ? Jb_list.jb_name[(Jb_list.seq || []).findIndex((s) => s === Jb)]
                        : ''}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* 환경센서 메뉴 */}
      <div className="menu-item" onClick={() => toggleSubmenu(2)}>
        <div className="menu-name-container">
          {submenuVisible === 2 ? (
            <div style={{ color: "var(--brand-navy, #013c8f)" }}>환경센서</div>
          ) : (
            <div>환경센서</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MeasurementLeftMenuBar;
